export const SET_IORS = 'SET_IORS';
export const setIORs = (data) => ({
  type: SET_IORS,
  data,
});

export const ADD_IOR = 'ADD_IOR';
export const addIOR = (newIorData) => ({
  type: ADD_IOR,
  newIorData,
});
